// import * as React from 'react'
import { useEffect } from 'react'
import { useApp } from '@pareto-engineering/design-system'

const Loading = (/* { children } */) => {
  const {
    userTheme,
  } = useApp()

  const loaderIconPath = userTheme === 'light' ? 'loader-light.gif' : 'loader-dark.gif'

  useEffect(() => {
    const loaderElement = document.getElementById('loader')
    const iconElement = document.getElementById('loader-icon')
    iconElement.src = `/${loaderIconPath}`
    loaderElement.classList.remove('loaded')
    return () => loaderElement.classList.add('loaded')
  }, [])
  return null
}

Loading.defaultProps = {
  children:'Loading',
}

export default Loading
